import { createActionCreator } from "common/ReduxUtils";
import { StorageCargoActionTypes } from "../StorageCargoAction.types";

export const setNumOfPallets = createActionCreator<number>(
  StorageCargoActionTypes.STORAGE_SET_NUM_OF_PALLETS,
  "numOfPallets"
);
